import React from 'react';
import { PipelineToolbar } from './toolbar';
import { PipelineUI } from './ui';

/**
 * Main App component for the Pipeline Editor
 * Full-screen canvas with floating toolbar at top
 * Enhanced with modern styling and smooth gradients
 *
 * @returns {React.Component} Main application component
 */
function App() {
  return (
    <div className="h-screen w-screen relative overflow-hidden">
      {/* Gradient background for visual appeal */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50/30 to-purple-50/20"></div>

      {/* Subtle grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)',
          backgroundSize: '20px 20px'
        }}
      ></div>

      {/* Full-screen pipeline editor canvas */}
      <div className="relative z-10 w-full h-full">
        <PipelineUI />
      </div>

      {/* Floating toolbar pinned at top */}
      <PipelineToolbar />
    </div>
  );
}

export default App;
